import {ComponentType} from 'react'
import {MHCLGLandingPage} from './MHCLGLandingPage'

/**
 * Registry of custom landing pages keyed by identifier.
 * The key corresponds to the `customLandingPage` value in AppMetaData.
 */
export const customLandingPages: Record<string, ComponentType> = {
  mhclg: MHCLGLandingPage
}

/**
 * Retrieve a custom landing page component by its identifier.
 * @param key The landing page identifier from backend configuration
 * @returns The landing page component, or undefined if not found
 */
export const getCustomLandingPage = (key: string): ComponentType | undefined => {
  return customLandingPages[key]
}
